<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<!-- -------------------------------------------------------------------------- -->
<!--                                 Toastr Template                            -->
<!-- -------------------------------------------------------------------------- -->
<p-toast position="bottom-right" baseZIndex="10000" autoZIndex="true">
  <!-- Custom Template for rendering each toast message -->
  <ng-template let-message pTemplate="message">
    <div class="custom-toast">
      <!-- -------------------------------------------------------------------------- -->
      <!-- Progress Bar: Shows the progress of the toast message (based on life)    -->
      <!-- -------------------------------------------------------------------------- -->
      <div
        class="custom-toast-progress"
        [ngClass]="{
          'success-progress': message.severity === 'success',
          'error-progress': message.severity === 'error',
          'warning-progress': message.severity === 'warning',
          'info-progress': message.severity === 'info',
        }"
        [style.animation-duration]="message.life + 'ms'"
      ></div>

      <!-- -------------------------------------------------------------------------- -->
      <!-- Dynamic Icon: Displays a different icon based on the toast severity      -->
      <!-- -------------------------------------------------------------------------- -->
      <span
        class="custom-toast-icon"
        [innerHTML]="getIconForToastType(message.severity)"
      ></span>

      <!-- -------------------------------------------------------------------------- -->
      <!-- Message Text: Displays the main message of the toast                    -->
      <!-- -------------------------------------------------------------------------- -->
      <span class="custom-toast-message">{{ message.detail }}</span>

      <!-- -------------------------------------------------------------------------- -->
      <!-- Close Button: Allows user to close the toast message manually            -->
      <!-- -------------------------------------------------------------------------- -->
      <button
        *ngIf="message.data.clossable"
        type="button"
        class="custom-toast-close"
        (click)="clearToast(message.key)"
      >
        <!-- Displays the close icon -->
        <span [innerHTML]="closeIcon"></span>
      </button>
    </div>
  </ng-template>
</p-toast>

<div class="g99-app-root">
  @if (isAuthenticated) {
    <div class="g99-lib-client-header">
      <g99-lib-client-header />
    </div>
  }

  <div class="g99-app-content" [ngClass]="{ authenticated: isAuthenticated }">
    <!-- ------------------------- Twilio setup banner ------------------------- -->
    @if (isAuthenticated) {
      <div class="maintainence-banner">
        <g99-lib-maintainence-banner
          [shouldShowBanner]="false"
          [title]="maintainenceBannerTitle"
          [description]="maintainenceBannerDescription"
        />
      </div>

      <!-- Black Friday announcement: always above the other banners -->
      <g99-lib-holiday-ready-banner />

      <div
        class="twilio-banner"
        [class.twilio-banner--visible]="showTwilioSetupBanner"
      >
        <g99-lib-generic-banner
          [isVisible]="showTwilioSetupBanner"
          [config]="twilioConfig"
          (closeClick)="closeTwilioBanner()"
        />
      </div>

      <div class="google-banner">
        <g99-lib-generic-banner
          [isVisible]="showGoogleBanner"
          [config]="googleConfig"
          (closeClick)="closeGoogleBanner()"
        />
      </div>
    }

    <!-- ---------------------------- Router outlet ---------------------------- -->
    <router-outlet />
  </div>
</div>
